import React from "react";
import Navigation from "../../../components/Navigation";
import EditProjectForm from "./EditProjectForm/EditProjectForm";

const CreateProject = () => {
  return (
    <div>
      <Navigation />
      <EditProjectForm />
    </div>
  );
};

export default CreateProject;